export default {
  orgProductTypes: [],
  orgPriceTypes: [],
  orgProductCouponCodes: [],
  orgProductRedemptionInstructions: "",
  orgProductMintableContractDetails: {
    contractType: "",
    network: {
      text: "",
      value: 0,
      chainIdHex: "0x0",
      chainId: 0,
      currency: "",
    },
    contractAddress: "",
    mintFunctionABI: [],
    mintFunctionName: "",
    mintFunctionParameters: "",
    mintPriceETH: "",
  },
};
